import {FIELDS} from '@/pages/Contacts/constants';

const contactsFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'fullName',
    field: FIELDS.FULL_NAME,
    title: 'FullName',
    label: 'FullName',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 150,
    locked: true
  }, {
    key: 'id',
    field: FIELDS.ID,
    title: 'Id',
    label: 'Id',
    //cell: 'navigation',
    sortable: true,
    hidden: true,
    width: 75,
  }, {
    key: 'companyName',
    field: FIELDS.COMPANY_NAME,
    title: 'CompanyName',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'IsPrimary',
    field: FIELDS.IS_PRIMARY,
    title: ' Is Primary',
    label: 'IsPrimary',
    cell: 'checkMark',
    sortable: true,
    hidden: false,
    width: 100,
  }, {
    key: 'title',
    field: FIELDS.TITLE,
    title: 'Title',
    label: 'Title',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'firstName',
    field: FIELDS.FIRST_NAME,
    title: 'FirstName',
    label: 'FirstName',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'lastName',
    field: FIELDS.LAST_NAME,
    title: 'LastName',
    label: 'LastName',
    sortable: true,
    hidden: false,
    width: 150,
  }, /*{
    key: 'fullName',
    field: FIELDS.FULL_NAME,
    title: 'FullName',
    label: 'FullName',
    sortable: true,
    hidden: false,
    width: 150,
  },*/ {
    key: 'gender',
    field: FIELDS.GENDER,
    title: 'Gender',
    label: 'Gender',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'location',
    field: FIELDS.LOCATION,
    title: 'Location',
    label: 'Location',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'locationPhone',
    field: FIELDS.LOCATION_PHONE,
    title: 'Location Phone',
    label: 'Location Phone',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'dob',
    field: FIELDS.DOB,
    title: 'DOB',
    label: 'DOB',
    sortable: true,
    cell: 'formatDate',
    hidden: false,
    width: 150,
  }, {
    key: 'email1',
    field: FIELDS.EMAIL1,
    title: 'Email1',
    label: 'Email1',
    sortable: true,
    cell: 'mailToEmail',
    hidden: false,
    width: 150,
  }, {
    key: 'email2',
    field: FIELDS.EMAIL2,
    title: 'Email2',
    label: 'Email2',
    sortable: true,
    cell: 'mailToEmail',
    hidden: false,
    width: 150,
  }, {
    key: 'main',
    field: FIELDS.MAIN,
    title: 'Main',
    label: 'Main',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'direct',
    field: FIELDS.DIRECT,
    title: 'Direct',
    label: 'Direct',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'mobile',
    field: FIELDS.MOBILE,
    title: 'Mobile',
    label: 'Mobile',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'phone1TypeName',
    field: FIELDS.PHONE1_TYPE_NAME,
    title: 'Phone1TypeName',
    label: 'Phone1TypeName',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'phone1',
    field: FIELDS.PHONE1,
    title: 'Phone1',
    label: 'Phone1',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'phone1Ext',
    field: FIELDS.PHONE1_EXT,
    title: 'Phone1Ext',
    label: 'Phone1Ext',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'phone2TypeId',
    field: FIELDS.PHONE2_TYPE_ID,
    title: 'Phone2TypeId',
    label: 'Phone2TypeId',
    sortable: true,
    hidden: true,
    width: 150,
  }, {
    key: 'phone2TypeName',
    field: FIELDS.PHONE2_TYPE_NAME,
    title: 'Phone2TypeName',
    label: 'Phone2TypeName',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'phone2',
    field: FIELDS.PHONE2,
    title: 'Phone2',
    label: 'Phone2',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'phone2Ext',
    field: FIELDS.PHONE2_EXT,
    title: 'Phone2Ext',
    label: 'Phone2Ext',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'comment',
    field: FIELDS.COMMENT,
    title: 'Comment',
    label: 'Comment',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default contactsFields;
